var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginCloseEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3334 3.33325L16.6667 16.6666M13.7501 13.9633C12.6226 14.5708 11.3484 14.9999 10.0001 14.9999C7.0584 14.9999 4.47173 12.9566 2.98923 11.4824C2.59757 11.0933 2.40174 10.8991 2.27757 10.5166C2.1884 10.2441 2.1884 9.75575 2.27757 9.48325C2.40257 9.10075 2.5984 8.90575 2.99007 8.51659C3.73757 7.77325 4.76507 6.88659 5.97673 6.18909M16.2501 12.1949C16.5276 11.9508 16.7817 11.7099 17.0101 11.4833L17.0126 11.4808C17.4026 11.0924 17.5984 10.8974 17.7226 10.5174C17.8117 10.2449 17.8117 9.75575 17.7226 9.48325C17.5976 9.10159 17.4026 8.90658 17.0109 8.51742C15.5276 7.04325 12.9426 4.99992 10.0001 4.99992C9.7184 4.99992 9.44062 5.0177 9.16673 5.05325M11.1026 11.2499C10.7798 11.5349 10.3592 11.684 9.92899 11.6658C9.49876 11.6476 9.09227 11.4636 8.7947 11.1523C8.49712 10.8411 8.33157 10.4267 8.33273 9.99613C8.33388 9.56552 8.50166 9.15207 8.8009 8.84242",
    stroke: "#F3F3F3",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCloseEye);
export default __webpack_public_path__ + "static/media/login-close-eye.2c9a1006450ceadff19eb9be9d58fa07.svg";
export { ForwardRef as ReactComponent };